<template>
  <div class="building" id="building">
<!--    <div class="build-animate">-->
<!--      <div class="building-text" id="building-text">-->
<!--        <div class="building-text-wrap">-->
<!--          <span class="building-text-small">A New look on vibrant Eas Village</span>-->
<!--          <span class="building-text-intro">Introducing</span>-->
<!--          <br class="break">-->
<!--          <span class="image-wrapper">-->
<!--              <img id="titleImage" src="../assets/logo.svg" alt="Logo">-->
<!--            </span>-->
<!--        </div>-->
<!--        <span class="building-text-luxury">a luxury condominium landmark designed by Morris Adjmi.</span>-->
<!--      </div>-->
<!--      <img id="titleImage2" class="title-image-mobile" src="../assets/logo.svg" alt="Logo" :class="{ mobileImage: !showMobileImage}">-->
<!--    </div>-->
    <div class="building-initial">
      <div class="building-left">
        <navigation v-if="leftNavigation"></navigation>
        <Inquiries :building="inquiries"></Inquiries>
      </div>
      <div class="building-wrapp">
        <div class="building-head" v-if="buildingHeadNav">
          <div class="building-head-nav">
            <div id="nav-mobile-building" class="menu-mobile" @click="toggleNav()">
              <div class="bar1"></div>
              <div class="bar2"></div>
              <div class="bar3"></div>
            </div>
            <span class="building-head-nav--item" @click="checkInquiries">Availability</span>
            <span class="building-head-nav--item" @click="toggleInquiries">Inquiries</span>
          </div>
          <img src="../assets/logo.svg" alt="Logo" class="building-head--logo">
        </div>
        <span class="scrollDown downLink" v-if="scrollDown">
            <div class="downLinkFirst">
                <a class="downLinkItem" href="https://www.google.com/maps/place/214+W+72nd+St,+New+York,+NY+10023/@40.778766,-73.9848932,17z/data=!3m1!4b1!4m5!3m4!1s0x89c2588a0bebb1f9:0x882ec6eb3c9e86f8!8m2!3d40.778766!4d-73.9827045" target="_blank">214 W 72nd Street, New York, NY 10023, </a>
                <a class="downLinkItem" href="tel:631-834-8523">631-834-8523</a>
            </div>
            <div class="downLinkItemSecond">
                <a class="downLinkItem" target="_blank" href="http://alanhilldesign.com/FairHousingNotice.pdf">Fair Housing </a>|
                <span class="downLinkItem" @click="openDocument"> Privacy Policy</span>
            </div>

        </span>
        <span class="scrollDown" v-if="scrollDown">Scroll down</span>

        <div class="build-animate__video information" id="Info" @click="closeInquiries">
          <video id="myVideo" autoplay loop muted playsinline>
            <source :src="data[0].video" type="video/mp4">
          </video>
            <span id="scrollText" class="build-animate__video--text" v-html="data[0].title"></span>
        </div>
      </div>
    </div>

    <parallax
      :fixed="true"
      :sectionClass="isFixed ? 'changeSection' : undefined"
      :containerClass="isFixed ? 'changeSection2' : undefined"
    >
      <!-- section text image -->
      <div class="left-section building-first-section">
        <div class="left-section__description">
          <span class="left-section__description--text scrollFadeText">
            {{ data[1].text }}
          </span>
        </div>
        <div class="left-section__view scrollFade">
          <div class="building--image building-01" :style="{ backgroundImage: `url('${data[1].image}')` }"></div>
        </div>
      </div>


      <div class="view-section scrollFade">
        <div class="building--image building-02" :style="{ backgroundImage: `url('${data[2].image}')` }"></div>
      </div>

      <!-- section image text -->
      <div class="left-section left-section-second">
        <div class="left-section__view scrollFade">
          <div class="building--image building-03" :style="{ backgroundImage: `url('${data[3].image}')` }"></div>
        </div>
        <div class="left-section__description reverse">
          <span class="left-section__description--text scrollFadeText">
            {{ data[3].text }}
          </span>
        </div>
      </div>

      <!-- section text image -->
      <div class="left-section">
        <div class="left-section__description">
          <span class="left-section__description--text scrollFadeText">
            {{ data[4].text }}
          </span>
        </div>
        <div class="left-section__view scrollFade">
          <div class="building--image building-04" :style="{ backgroundImage: `url('${data[4].image}')` }"></div>
        </div>
      </div>
    </parallax>

  </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'PageView',
        'pagePath': '/building',
        'pageTitle': 'Parker West | Building'
    })
  import Parallax from 'vue-parallaxy';
  import Inquiries from "../components/Inquiries";
  import Navigation from "../layouts/Navigation";

  export default {
    name: "Building.vue",
    data: () => ({
      isFixed: false,
      backImage: '',
      descriptionContent: [
        {
          title: 'Historical elements with a modern trend-setting vision some.',
          text: '45 East 7th, in Morris Adjmi’s trademark style, channels historical architectural elements with a modern, trend-setting vision to build a landmark to the community’s past, present and future in the most desirable location downtown—where Astor Place, Noho and the Village meet.',
          image: 'Building1.png'
        },
        {
          title: 'Historical elements with a modern trend-setting vision some.',
          text: '45 East 7th, in Morris Adjmi’s trademark style, channels historical architectural elements with a modern, trend-setting vision to build a landmark to the community’s past, present and future in the most desirable location downtown—where Astor Place, Noho and the Village meet.',
          image: 'Building2.png'
        },
        {
          title: '',
          text: '45 East 7th, in Morris Adjmi’s trademark style, channels historical architectural elements with a modern, trend-setting vision to build a landmark to the community’s past, present and future in the most desirable location downtown—where Astor Place, Noho and the Village meet.',
          image: 'Building3.png'
        },
        {
          title: '',
          text: '45 East 7th, in Morris Adjmi’s trademark style, channels historical architectural elements with a modern, trend-setting vision to build a landmark to the community’s past, present and future in the most desirable location downtown—where Astor Place, Noho and the Village meet.',
          image: 'Building4.png'
        },
        {
          title: 'Historical elements with a modern trend-setting vision some.',
          text: '45 East 7th, in Morris Adjmi’s trademark style, channels historical architectural elements with a modern, trend-setting vision to build a landmark to the community’s past, present and future in the most desirable location downtown—where Astor Place, Noho and the Village meet.',
          image: 'Building5.png'
        }
      ],
      imagePath: 'building.png',
      scrollPosition: 0,
      showMobileImage: false,
      inquiries: false,
      leftNavigation: false,
      buildingHeadNav: true,
      scrollDown: true
    }),
      metaInfo: {
          title: 'Parkerwest Building',
          // Define meta tags here.
          meta: [
              {name: 'description', content: 'Parkerwest building page'}
          ],
          link: [
              {rel: 'canonical', href: 'http://test.parkerwest.com/'}
          ]
      },
    components: {
      Parallax,
      Inquiries,
      Navigation
    },
    computed: {
        data() {
            return window.data.building;
        }
    },
    created() {
      if(window.innerWidth <= 600) {
        this.backImage = 'building.png'
        this.showMobileImage = true
        let myMain = document.getElementsByClassName('app-main')[0];
        myMain.scrollTop = 0;
      } else {
        this.backImage = ''
      }
    },
    // beforeRouteLeave () {
    //   const root = document.getElementsByTagName( 'html' )[0];
    //   root.removeAttribute( 'class', 'addParallax' );
    // },
    beforeDestroy() {
        const root = document.getElementsByTagName( 'html' )[0];
        root.removeAttribute( 'class', 'addParallax' );
    },
    methods: {
        openDocument() {
            window.open('http://test.parkerwest.com/policy.pdf', '_blank')
        },
      checkInquiries () {
        if (this.inquiries || this.leftNavigation) {
          this.leftNavigation = false
          this.inquiries = false
          const element = document.getElementById("nav-mobile-building");
          element.classList.remove("change");
          return
        }
        this.$router.push({
          name: 'availability'
        })
      },
      handleScroll () {
        const elmnt = document.getElementById("building");
        const y = elmnt.scrollTop;

        // mobile navigation image
        // const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        // // const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        // const headImage = document.getElementById("titleImage");
        // const menuMobile = document.getElementsByClassName('isBuilding')[0];

        // if(screenWidth < 600) {
        //   if (y >= 44) {
        //     headImage.classList.add("fixLogo")
        //     menuMobile.classList.add("fixMenu")
        //     this.$emit('isPass', true)
        //     this.showMobileImage = false
        //   } else {
        //     headImage.classList.remove("fixLogo")
        //     menuMobile.classList.remove("fixMenu")
        //     this.$emit('isPass', false)
        //     this.showMobileImage = true
        //   }
        // }
        const scrollText = document.getElementById("scrollText");
        if (y > 10) {
          scrollText.classList.add('fade-out')
        } else {
          scrollText.classList.remove('fade-out')
        }

        // text move
        // const text = document.getElementById('building-text');
        // const setStyle = text.style;
        // setStyle.opacity = 1 - y/90;


        // navigation
        const info = document.getElementsByClassName("information")[0].offsetHeight;
        const showNavigation = y / info
        if(showNavigation > 0.9 ) {
          this.$emit('navOpacity', showNavigation / 1.3)
        } else {
          this.$emit('navOpacity', 0)
        }

        // scroll down
        const scrollDown = document.getElementsByClassName('scrollDown')[0];
        const scrollDown1 = document.getElementsByClassName('scrollDown')[1];
        // const infoH = scrollDown.getBoundingClientRect().top
        const screenH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        if(((y + screenH) / info) > 1) {
          scrollDown.style.display = 'none';
          scrollDown1.style.display = 'none'
        } else {
          scrollDown.style.display = 'block';
          scrollDown1.style.display = 'block'
        }

        //Info
        const test = document.getElementById('Info').offsetHeight;
        const root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
        this.buildingHeadNav = y + 90 < test;
        if(y >= test) {
          this.isFixed = true
          root.setAttribute( 'class', 'addParallax' );
          this.$emit('setIndex', 10)
        } else {
          this.isFixed = false
          root.removeAttribute( 'class', 'addParallax' );
          this.$emit('setIndex', null)
        }


        // Scroll fade
        let slides = document.getElementsByClassName("scrollFade");
        let slidesTitle = document.getElementsByClassName("scrollFadeText");
        let slidesTitleReverse = document.getElementsByClassName("scrollFadeTextReverse");
        let slidesBody = document.getElementsByClassName("scrollFadeBody");
        // const headerHeight = document.getElementsByClassName('header')[0]

        for (let i = 0; i < slidesTitle.length; i++) {
          let elPos = slidesTitle[i].getBoundingClientRect().top
          if(elPos < 120) {
            slidesTitle[i].style.opacity = (elPos / 120)
          } else {
            slidesTitle[i].style.opacity = 1
          }
          if ((elPos - innerHeight) < innerHeight && slidesTitle[i].offsetHeight + elPos > innerHeight ) {
            slidesTitle[i].style.opacity = 1 - (elPos / innerHeight)
          }
        }
        for (let i = 0; i < slidesTitleReverse.length; i++) {
          let elPos = slidesTitleReverse[i].getBoundingClientRect().top
          if(elPos /2 < window.innerHeight) {
            slidesTitleReverse[i].style.opacity = 1 - (elPos + 100 - (window.innerHeight / 1.2)) / window.innerHeight
          } else {
            slidesTitleReverse[i].style.opacity = 0
          }
          if (elPos < innerHeight && slidesTitle[i].offsetHeight + elPos > innerHeight ) {
            slidesTitle[i].style.opacity = 210 /elPos
          }
        }

        for (let i = 0; i < slidesBody.length; i++) {
          let elPos = slidesBody[i].getBoundingClientRect().top
          if(elPos < 60) {
            slidesBody[i].style.opacity = (elPos / 60)
          } else {
            slidesBody[i].style.opacity = 1
          }
        }

          if(window.innerWidth > 600) {
              for (let i = 0; i < slides.length; i++) {
                  let elPos = slides[i].getBoundingClientRect().top
                  const header = document.getElementById('header')
                  if ((elPos - innerHeight) < innerHeight && slides[i].offsetHeight + elPos > innerHeight ) {
                      slides[i].style.opacity = 1 - ((elPos - header.offsetHeight) / innerHeight)
                  }
              }
          }
      },
      showPage (value) {
        if (value === 'inquiries') {
          this.inquiries = !this.inquiries
          this.$bus.emit('showInquiries', this.inquiries);
        }
      },
      toggleNav () {
        if (this.inquiries) {
          this.inquiries = false
          return
        }
        const element = document.getElementById("nav-mobile-building");
        const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        element.classList.toggle("change");
        this.leftNavigation = !this.leftNavigation
        this.inquiries = false

        this.scrollDown = !(screenWidth < 600 && this.leftNavigation);

        this.disableScrollBuild()
      },
      async closeInquiries() {
        if (this.inquiries) {
          this.inquiries = false
          this.disableScrollBuild()
           return
        }

        if (this.leftNavigation) {
          await this.toggleNav()
        }

        this.disableScrollBuild()
      },
      toggleInquiries() {
        if (this.leftNavigation) {
          this.leftNavigation = false
          this.inquiries = false
          const element = document.getElementById("nav-mobile-building");
          element.classList.remove("change");
          return
        }
        this.inquiries = !this.inquiries
        if (this.leftNavigation) {
          this.leftNavigation = false
          const element = document.getElementById("nav-mobile-building");
          element.classList.remove("change");
        }

        this.disableScrollBuild()
      },
      disableScrollBuild() {
        const build = document.getElementById("building");
        if (this.leftNavigation || this.inquiries) {
          build.classList.add("disableScrolling")
        } else {
          build.classList.remove("disableScrolling")
        }
      }
    },
    mounted () {
      document.getElementById('building').addEventListener('scroll', this.handleScroll);
      document.getElementById('building').addEventListener('resize', ()=> {
        if(window.innerWidth <= 600) {
          this.backImage = 'building.png'
        } else {
          this.backImage = ''
        }
      });
    }

  }
</script>

<style scoped lang="scss">
  .changeSection {
    height: 100% !important;

  }
  .changeSection2 {
    position: relative !important;
    height: auto !important;
  }

  .mobileImage {
    visibility: hidden;
  }

  .fade-out {
    animation: fadeOut ease 1s forwards;
    -webkit-animation: fadeOut ease 1s forwards;
    -moz-animation: fadeOut ease 1s forwards;
    -o-animation: fadeOut ease 1s forwards;
    -ms-animation: fadeOut ease 1s forwards;
  }
  @keyframes fadeOut {
    0% {
      opacity:1;
    }
    100% {
      opacity:0;
    }
  }

  @-moz-keyframes fadeOut {
    0% {
      opacity:1;
    }
    100% {
      opacity:0;
    }
  }

  @-webkit-keyframes fadeOut {
    0% {
      opacity:1;
    }
    100% {
      opacity:0;
    }
  }

  @-o-keyframes fadeOut {
    0% {
      opacity:1;
    }
    100% {
      opacity:0;
    }
  }

  @-ms-keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

</style>
